<template lang="pug">
form.form-search(
  :target='localTarget',
  method='get',
  @submit='submit',
  ref='thisForm',
  @click='focus',
  v-click-outside='blur'
)
  input.form-search__input(
    ref='input',
    v-model='term',
    :name='fieldName',
    :placeholder='focused ? "" : placeholder'
  )
  button.form-search__button(type='submit')
</template>

<script>
export default {
  props: {
    target: {
      type: [String, Object],
      default: '',
    },
    hasFocus: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Поиск...',
    },

    fieldName: {
      type: String,
      default: 'term',
    },

    fieldValue: {
      type: String,
      default: '',
    },
  },

  data: () => ({
    focused: false,
    term: '',
  }),

  computed: {
    localTarget() {
      const { $router, target } = this;
      return $router ? $router.resolve(target).href : target;
    },
  },

  watch: {
    fieldValue(value) {
      this.term = value;
    },
  },
  mounted() {
    if (this.hasFocus) {
      this.$refs.input.focus();
    }
  },
  created() {
    this.term = this.fieldValue;
  },

  methods: {
    focus($event) {
      if (!this.focused) {
        this.focused = true;
        this.$emit('focus', $event);
      }
    },

    blur($event) {
      for (const pathElement of $event.composedPath()) {
        if (
          pathElement.classList &&
          (pathElement.classList.contains('search') ||
            pathElement.classList.contains('form-search__input') ||
            pathElement.classList.contains('form-search__button') ||
            pathElement.classList.contains('nav_svg_icon'))
        ) {
          return;
        }
      }
      this.focused = false;
      this.$emit('blur', $event);
    },

    submit($event) {
      $event.preventDefault();
      const { $router, target } = this;
      if (!$router || typeof target === 'string') return;

      const { fieldName, term } = this;
      this.$emit('submit', { term, fieldName });
    },
  },
};
</script>

<style lang="scss" scoped>
.form-search {
  &__input {
    background-image: none;
    line-height: normal;
    resize: none;
    user-select: text;
    transition: all 0.3s;
    width: 100%;
    border-style: solid;
    border-width: 1px;
    border-color: #cfd4d8;
    border-radius: 2px;
    background-color: #fff;
    box-shadow: inset 3px 2px 4px 0 rgba(128, 142, 156, 0.28);
    height: 35px;
    font-size: 14px;
    box-sizing: border-box !important;
    font-family: 'Open Sans', sans-serif;
    font-weight: 400;
    padding-left: 10px;
    padding-right: 40px;
    background-size: 19px 20px;
    background-position: right 10px top 50%;
    background-repeat: no-repeat;
    position: relative;
    z-index: 10;
    -webkit-appearance: textfield;

    &:focus {
      border: 1px solid #39f;
      outline: none;
    }
  }

  &__button {
    position: absolute;
    right: 10px;
    top: 7px;
    z-index: 30;
    background-color: transparent;
    text-decoration: none;
    text-align: center;
    cursor: pointer;
    border: none;
    width: 19px;
    height: 20px;
    background-image: url('data:image/svg+xml;charset=utf-8,<svg%20xmlns%3D"http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg"%20preserveAspectRatio%3D"xMidYMid"%20width%3D"19"%20height%3D"20"%20viewBox%3D"0%200%2019%2020"><defs><style>.cls-1%20%7B%20fill%3A%20%236e6bce%3B%20fill-rule%3A%20evenodd%3B%20%7D<%2Fstyle><%2Fdefs><path%20d%3D"M18.823%2018.49l-1.292%201.328c-.237.244-.622.244-.86%200l-5.148-5.29c-1.144.706-2.478%201.12-3.91%201.12C3.407%2015.648%200%2012.145%200%207.824%200%203.504%203.408%200%207.61%200c4.205%200%207.613%203.503%207.613%207.824%200%201.715-.544%203.296-1.454%204.586l5.053%205.195c.237.244.237.64%200%20.885zM7.61%201.565c-3.362%200-6.088%202.802-6.088%206.26%200%203.456%202.726%206.258%206.09%206.258%203.362%200%206.088-2.802%206.088-6.26%200-3.456-2.726-6.258-6.09-6.258z"%20class%3D"cls-1"%2F><%2Fsvg>');

    &:focus {
      outline: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Search.vue?6b586fd6